import { LitElement, html, css } from 'lit'

export class CartCount extends LitElement {
  static styles = [
    css`
      :host {
        display: flex;
        color: inherit;
      }
    `,
  ]

  static properties = {
    count: { type: Number },
    hideWhenZero: { type: Boolean, attribute: 'hide-when-zero' },
  }

  constructor() {
    super()

    window.MicroBus.on('count-change', (e) => {
      this.count = e.detail.count
    })
  }

  render() {
    return html`${this.hideWhenZero && this.count === 0 ? '' : this.count}`
  }
}

customElements.define('cart-count', CartCount)
